import { shadows } from "design-tokens";

/**
 * Figma's `menu/list` — padding and the gap between rows, in MUI spacing steps. The gap pairs with the
 * item's 8px vertical padding: a 40px row plus 4px keeps the 44px pitch the flush 10px rows had.
 */
export const MENU_PANEL_SPACING = { padding: 0.5, gap: 0.5 };

/**
 * A floor rather than Figma's fixed 224px frame: labels set the width, and this has held since a
 * ticket asked for it (`#33019`).
 */
export const MENU_PANEL_MIN_WIDTH = 232;

/** The 12px gutter and 8px vertical spacing of `ActionMenuDivider`, in MUI spacing steps. */
export const MENU_DIVIDER_SPACING = { x: 1.5, y: 1 };

/** Figma's `MenuList` sits on `MUI/shadowSmall`, not the `lg` that `ui/select`'s dropdown states. */
export const MENU_PANEL_SHADOW = shadows.sm;
